import React from 'react';
import { Button, Layout } from 'antd';
import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

const { Header } = Layout;

const Navbar = ({ collapsed, onCollapse }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.reload();
  };

  return (
    <Header className="navbar">
      <div className="navbar-left">
        <span className="sider-toggle" onClick={onCollapse}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </span>
        <div className="navbar-brand" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
          <h1 className="logo">CLIPS AI</h1>
        </div>
      </div>
      <div className="navbar-right">
        <Button
          type="primary"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          className="logout-button"
        >
          Logout
        </Button>
      </div>
    </Header>
  );
};

export default Navbar;